import React from 'react'
import { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import TermsAndCondition from '../terms-and-conditions/TermsAndCondition'
const TermsAndConditionsPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <TermsAndCondition></TermsAndCondition>
    </Fragment>
  )
}

export default TermsAndConditionsPage